export default __webpack_public_path__ + "static/media/youtubeIcon.be9c6785.svg";